import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { Dashboard as DashboardLayout } from "../../../../layouts";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { getFaqCmsSettings, saveFaqCmsSettings } from "../../../../redux/actions/faqCmsActions";
import styles from "../../../ChatbotSettings/styles";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";

class CustomFieldsSetting extends Component {
  newCustomField = {
    name: "",
    label: "",
    sourceFieldName: "",
    options: []
  };
  newOption = { value: "", label: "" };
  optionTextFieldStyle = {
    marginRight: "1.5em",
    width: "250px"
  };
  propertyTextFieldStyle = {
    margin: "2rem 0 3em 0",
    width: "250px"
  };

  renderCustomFieldOption = (option, optionIdx, customFieldIdx, errors) => {
    const { updateCustomFieldOption, removeCustomFieldOption } = this.props;
    const optionValue = _.get(option, "value", "");
    const optionLabel = _.get(option, "label", "");
    const { valueErrors, labelErrors } = errors;

    return (
      <div key={optionIdx} style={{ marginBottom: "1.5em", display: "flex", alignItems: "flex-start" }}>
        <TextField
          style={this.optionTextFieldStyle}
          value={optionValue}
          onChange={event =>
            updateCustomFieldOption(customFieldIdx, optionIdx, { value: event.target.value, label: optionLabel })
          }
          {...this.getErrorProps(valueErrors)}
          label="Value"
          variant="outlined"
        />
        <TextField
          style={this.optionTextFieldStyle}
          value={optionLabel}
          onChange={event =>
            updateCustomFieldOption(customFieldIdx, optionIdx, { value: optionValue, label: event.target.value })
          }
          {...this.getErrorProps(labelErrors)}
          label="Label"
          variant="outlined"
        />
        <IconButton
          color="primary"
          aria-label="remove option"
          component="span"
          onClick={() => removeCustomFieldOption(customFieldIdx, optionIdx)}
          style={{ justifyContent: "center", padding: "16px" }}
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      </div>
    );
  };

  getErrorProps = errors => {
    if (!errors || !errors.length) {
      return {};
    }

    return {
      error: true,
      helperText: errors[0]
    };
  };

  renderCustomFieldForm = (customField, customFieldIdx, errors) => {
    const { updateCustomFieldProperty, addCustomFieldOption, removeCustomField } = this.props;
    const options = _.get(customField, "options", []);
    const { nameErrors, labelErrors, sourceFieldNameErrors, optionsErrors } = errors;

    return (
      <React.Fragment>
        <div>
          <TextField
            style={this.propertyTextFieldStyle}
            value={_.get(customField, "name", "")}
            onChange={event => {
              updateCustomFieldProperty(customFieldIdx, "name", event.target.value);
              updateCustomFieldProperty(customFieldIdx, "label", event.target.value);
            }}
            label="Name"
            variant="outlined"
            {...this.getErrorProps(nameErrors)}
          />
        </div>

        <Typography variant="h4" gutterBottom={true}>
          Dropdown options
        </Typography>

        <br />
        <br />

        {options.map((option, i) =>
          this.renderCustomFieldOption(option, i, customFieldIdx, optionsErrors[i] ? optionsErrors[i] : {})
        )}

        <div>
          <Button color="primary" onClick={() => addCustomFieldOption(customFieldIdx, _.cloneDeep(this.newOption))}>
            <AddIcon />
            Add Option
          </Button>
        </div>

        <Grid item xs={12} style={{ marginTop: 65, marginBottom: 10 }}>
          {this.props.renderButton(customField.options.length > 0 ? false : true)}
          <Button
            onClick={() => removeCustomField(customFieldIdx)}
            style={{ marginLeft: 20, padding: "10px 17px", opacity: 0.4 }}
            size="small"
          >
            Delete Custom Field
          </Button>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const { customFields, addCustomField } = this.props;
    const customFieldsErrors = _.get(this.props, "customFieldsErrors", []);

    return (
      <React.Fragment>
        <Typography variant="h3" gutterBottom={true}>
          Custom Field Settings
        </Typography>

        {customFields.length === 0 ? (
          <div>
            <em style={{ color: "gray", margin: "1rem 0", display: "block" }}>Custom field is not created</em>
            <Button
              style={{ marginBottom: 10 }}
              color="primary"
              variant="contained"
              onClick={() => addCustomField(_.cloneDeep(this.newCustomField))}
            >
              Create Custom Field
            </Button>
          </div>
        ) : (
          customFields.map((customField, i) =>
            this.renderCustomFieldForm(customField, i, customFieldsErrors[i] ? customFieldsErrors[i] : {})
          )
        )}
      </React.Fragment>
    );
  }
}

const validateCustomFieldOption = option => {
  const errors = {
    valueErrors: [],
    labelErrors: []
  };
  const { value, label } = option;

  if (!value || !value.length) {
    errors.valueErrors.push("Value cannot be empty");
  }

  if (!label || !label.length) {
    errors.labelErrors.push("Label cannot be empty");
  }

  return errors;
};

const validateCustomField = customField => {
  const errors = {
    nameErrors: [],
    labelErrors: [],
    sourceFieldNameErrors: [],
    optionsErrors: []
  };
  const { name, label, sourceFieldName, options } = customField;

  if (!name || !name.length) {
    errors.nameErrors.push("Name cannot be empty");
  }

  if (!options) {
    return errors;
  }

  errors.optionsErrors = options.map(option => validateCustomFieldOption(option));

  return errors;
};

/**
 * This component is partially based on the views/ChatbotSettings/components/SettingsForm.
 */
class FaqCmsSettings extends Component {
  constructor(props) {
    super(props);

    const nonAdminsCanCreateSubjectAreas = _.get(props, "faqCmsSettings.nonAdminsCanCreateSubjectAreas", false);
    const customFields = _.get(props, "faqCmsSettings.customFields", []);

    this.state = {
      isLoading: true,
      formIsBeingSaved: false,
      formValues: {
        nonAdminsCanCreateSubjectAreas,
        customFields
      },
      errors: {
        customFields: customFields.map(customField => validateCustomField(customField))
      }
    };
  }

  async componentDidMount() {
    const { getFaqCmsSettings, pushMessage } = this.props;
    await getFaqCmsSettings();
    const { faqCmsSettings, getSettingsApiCallResponse } = this.props;

    if (getSettingsApiCallResponse !== 200) {
      pushMessage({ type: "error", message: "Failed to get FAQ settings. Please try again later." });
      return;
    }

    const { errors } = this.state;
    const customFieldsErrors = _.get(faqCmsSettings, "customFields", []).map(customField =>
      validateCustomField(customField)
    );
    this.setState({
      formValues: faqCmsSettings,
      errors: { ...errors, customFields: customFieldsErrors },
      isLoading: false
    });
    this.setState({ isLoading: false });
  }

  handleNonAdminsCanCreateSubjectAreasChange = event => {
    const newFormValues = { ...this.state.formValues, nonAdminsCanCreateSubjectAreas: event.target.checked };
    this.setState({ formValues: newFormValues });
  };

  /**
   * Return array of errors for the settings form.
   * Note that not all errors are returned (e.g. if a custom field has property errors, the option errors are not
   * checked).
   * This is fine since we show just the first error in handleSubmit.
   * For no errors return an empty array.
   */
  validateForm = () => {
    const { errors } = this.state;
    if (!errors) {
      return [];
    }

    const { customFields } = errors;
    if (!customFields) {
      return [];
    }

    const customFieldPropertyErrorKeys = ["nameErrors", "labelErrors", "sourceFieldNameErrors"];

    for (const customFieldErrors of customFields) {
      // Check if custom field properties have any errors (e.g. "name" property)
      const propertyErrors = customFieldPropertyErrorKeys
        .map(propertyKey => {
          if (customFieldErrors[propertyKey] && customFieldErrors[propertyKey].length) {
            return customFieldErrors[propertyKey][0]; // Return first error
          }

          return undefined;
        })
        .filter(err => err); // Create array with just the first errors for the custom field properties
      if (propertyErrors.length) {
        return propertyErrors;
      }

      const { optionsErrors } = customFieldErrors;
      if (!optionsErrors) {
        continue;
      }

      // Check if options have any errors (e.g. missing "value").
      // Return "value" errors first and then "label" errors (if there are any).
      const errorsForEachOption = optionsErrors
        .map(optionErrors => {
          if (!optionErrors) {
            return undefined;
          }

          const { valueErrors, labelErrors } = optionErrors;
          if (valueErrors && valueErrors.length) {
            return valueErrors[0]; // Return first value error
          }
          if (labelErrors && labelErrors.length) {
            return labelErrors[0]; // Return first label error
          }

          return undefined;
        })
        .filter(err => err);

      if (errorsForEachOption.length) {
        return errorsForEachOption; // Array of just the first error for each option in the current custom field
      }
    }

    return [];
  };

  handleSubmit = async event => {
    if (event) event.preventDefault();
    const { saveFaqCmsSettings, pushMessage } = this.props;
    const formErrors = this.validateForm();

    if (formErrors.length) {
      pushMessage({
        type: "error",
        message: `${formErrors[0]}. Please fix the error before saving the settings again.`
      });
      return;
    }

    this.setState({ formIsBeingSaved: true });

    await saveFaqCmsSettings(this.state.formValues);
    const { saveSettingsApiCallResponse } = this.props;

    if (saveSettingsApiCallResponse === 200) {
      pushMessage({ type: "success", message: "FAQ settings saved." });
    } else {
      pushMessage({ type: "error", message: "Failed to save FAQ settings. Please try again later." });
    }
    this.setState({ formIsBeingSaved: false });
  };

  renderSubmitButton = isDisabled => {
    const { classes } = this.props;
    return (
      <Button disabled={isDisabled} variant="contained" color="primary" size="large" type="submit">
        {this.state.formIsBeingSaved && <CircularProgress color="#fff" size={23} />}
        {!this.state.formIsBeingSaved && "Save Settings"}
      </Button>
    );
  };

  updateCustomFieldOption = (customFieldIdx, optionIdx, option) => {
    const { formValues, errors } = this.state;
    const { customFields } = formValues;
    customFields[customFieldIdx].options[optionIdx] = option;
    const customFieldsErrors = customFields.map(customField => validateCustomField(customField));

    this.setState({
      formValues: {
        ...formValues,
        customFields
      },
      errors: { ...errors, customFields: customFieldsErrors }
    });
  };

  addCustomFieldOption = (customFieldIdx, option) => {
    const { formValues, errors } = this.state;
    const { customFields } = formValues;
    customFields[customFieldIdx].options.push(option);
    const customFieldsErrors = customFields.map(customField => validateCustomField(customField));
    this.setState({
      formValues: {
        ...formValues,
        customFields
      },
      errors: { ...errors, customFields: customFieldsErrors }
    });
  };

  removeCustomFieldOption = (customFieldIdx, optionIdx) => {
    const { formValues, errors } = this.state;
    const { customFields } = formValues;
    customFields[customFieldIdx].options.splice(optionIdx, 1);
    this.setState({
      formValues: {
        ...formValues,
        customFields
      }
    });
  };

  /**
   * Used to change e.g. the input name or the input label of the custom field.
   */
  updateCustomFieldProperty = (customFieldIdx, property, value) => {
    const { formValues, errors } = this.state;
    const { customFields } = formValues;
    customFields[customFieldIdx][property] = value;
    const customFieldsErrors = customFields.map(customField => validateCustomField(customField));
    this.setState({
      formValues: {
        ...formValues,
        customFields
      },
      errors: { ...errors, customFields: customFieldsErrors }
    });
  };

  removeCustomField = async customFieldIdx => {
    const { formValues, errors } = this.state;
    const customFields = [...formValues.customFields];
    customFields.splice(customFieldIdx, 1);
    this.setState(
      {
        formValues: {
          ...formValues,
          customFields
        }
      },
      () => this.handleDelete()
    );
  };

  handleDelete = async () => {
    const { saveFaqCmsSettings, pushMessage } = this.props;
    await saveFaqCmsSettings(this.state.formValues);
    if (this.props.saveSettingsApiCallResponse === 200) {
      pushMessage({ type: "success", message: "FAQ custom field deleted." });
    } else {
      pushMessage({ type: "error", message: "Failed to delete FAQ settings. Please try again later." });
    }
  };

  addCustomField = customField => {
    const { formValues, errors } = this.state;
    const { customFields } = formValues;
    customFields.push(customField);
    customFields[0]["sourceFieldName"] = "site";
    this.setState({
      formValues: {
        ...formValues,
        customFields
      }
    });
  };

  renderSettingsForm = () => {
    const centerTextVertically = { margin: "auto 0", display: "flex", alignItems: "center" };
    const { formValues, errors } = this.state;

    return (
      <Paper elevation={0}>
        <form onSubmit={this.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={centerTextVertically}>
              <Typography variant="body1">Non-admins can create new subject areas:</Typography>
              <Switch
                checked={_.get(formValues, "nonAdminsCanCreateSubjectAreas", false)}
                onChange={this.handleNonAdminsCanCreateSubjectAreasChange}
                name="nonAdminsCanCreateSubjectAreas"
              />
            </Grid>
            <Grid item xs={12}>
              <CustomFieldsSetting
                customFields={_.get(formValues, "customFields", [])}
                updateCustomFieldProperty={this.updateCustomFieldProperty}
                updateCustomFieldOption={this.updateCustomFieldOption}
                removeCustomField={this.removeCustomField}
                addCustomFieldOption={this.addCustomFieldOption}
                removeCustomFieldOption={this.removeCustomFieldOption}
                addCustomField={this.addCustomField}
                customFieldsErrors={errors.customFields}
                renderButton={this.renderSubmitButton}
              />
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <DashboardLayout title="FAQ CMS Settings" isLoading={this.state.isLoading}>
        <Paper className={classes.root} elevation={1}>
          {this.renderSettingsForm()}
        </Paper>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => {
  const { settings, getSettingsApiCallResponse, saveSettingsApiCallResponse } = state.faqCms;

  return {
    faqCmsSettings: settings,
    getSettingsApiCallResponse,
    saveSettingsApiCallResponse
  };
};

const mapDispatchToProps = { pushMessage, getFaqCmsSettings, saveFaqCmsSettings };

FaqCmsSettings = connect(mapStateToProps, mapDispatchToProps)(FaqCmsSettings);

export default withStyles(styles)(FaqCmsSettings);
